/**
 * @property {string} cn
 * @property {boolean} isPrepaid
 * @property {boolean} isCustomerAdmin
 * @property {string} customerId
 * @property {string} billingAccountId
 */
export default class CnData {
  /**
   *
   * @param {{
   *   cn: string,
   *   isCustomerAdmin: boolean,
   *   isPrepaid: boolean,
   *   sn: string,
   *   subAccount: string,
   *   subId: string
   * }} userData
   * @param {{
   *   billingType: string,
   *   category: string,
   *   customerId: string,
   *   deviceInUse: { name: string }[]
   *   firstActivationDate: string,
   *   id: string,
   *   owner: { fullName: string, doNotPublish: boolean, languagePrefference: string },
   *   paidBy: { id: number, paymentVariableSymbol: string },
   *   resource: { ownedInstalledResource: { "@type": string, id: { "@type": string } }}
   *   status: string,
   *   switchOndate: string,
   * }} loggedInSubscriptionInfo
   */
  constructor({ userData, loggedInSubscriptionInfo }) {
    this.cn = userData.cn;
    this.isPrepaid = userData.isPrepaid;
    this.isCustomerAdmin = userData.isCustomerAdmin;
    this.customerId = loggedInSubscriptionInfo.customerId;
    this.billingAccountId = loggedInSubscriptionInfo.paidBy.id;
  }
}
